import { transport } from 'config/transport';

export function callApiAddOffOneMonthForStudent(classId, studentId, month) {
    return transport.post(`/mamnon/classes/${classId}/offonemonth/students/${studentId}`, {}, { params: { month } });
}
